import React, { ComponentProps } from 'react';

import { Chip } from '@mui/material';

import { DreStatus } from 'pages/financeiro/dre/types';

interface DreListLojaColumnProp {
    dreStatusEnum: DreStatus['dreStatusEnum'];
    title: string;
}

const color: Record<DreStatus['dreStatusEnum'], ComponentProps<typeof Chip>['color']> = {
    A_PREENCHER: 'warning',
    EM_PREENCHIMENTO: 'info',
    FINALIZADO: 'success',
    BLOQUEADO: 'error',
} as const;

export function DreStatusChip({ dreStatusEnum, title }: DreListLojaColumnProp) {
    return <Chip label={title} variant="outlined" size="small" color={color[dreStatusEnum]} sx={{ width: '100%' }} />;
}
